import { render, staticRenderFns } from "./AddNewTopic.vue?vue&type=template&id=546f9ede"
import script from "./AddNewTopic.vue?vue&type=script&lang=js"
export * from "./AddNewTopic.vue?vue&type=script&lang=js"
import style0 from "./AddNewTopic.vue?vue&type=style&index=0&id=546f9ede&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports